import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getLatestStepVersion} from 'pipelines/StepConnectionUtils';

import {ParseClipboardContentFn} from './CopyPasteTypes';
import {parseApiIdsClipboardContent} from './parseApiIdsClipboardContent';

const SCRATCH_PLATE_IDS_CONFIG_KEY = 'scratchPlateIds';

/** @package */
export const parsePlateIdsClipboardContent: ParseClipboardContentFn = (_pipelineId, text) => {
  if (!BenchlingConfig.PIPELINES_ENABLE_EXPERIMENTAL_SCRATCH_PLATE_STEPS) {
    return Promise.resolve(null);
  }
  const scratchPlateIds = parseApiIdsClipboardContent(text, ModelTypeConstants.SCRATCH_PLATE);
  if (scratchPlateIds == null) {
    return Promise.resolve(null);
  }
  return Promise.resolve([
    {
      stepType: PipelineStepType.IMPORT_PLATES,
      stepVersion: getLatestStepVersion(PipelineStepType.IMPORT_PLATES),
      config: {[SCRATCH_PLATE_IDS_CONFIG_KEY]: scratchPlateIds},
      runAfterCreate: true,
    },
  ]);
};
